/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Empty_DescriptionInputs */

const he_account_reviews_empty_description = /** @type {(inputs: Account_Reviews_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כתוב ביקורות בדפי המוצרים כדי לשתף את חוויתך`)
};

const en_account_reviews_empty_description = /** @type {(inputs: Account_Reviews_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write reviews on item pages to share your experience`)
};

/**
* | output |
* | --- |
* | "Write reviews on item pages to share your experience" |
*
* @param {Account_Reviews_Empty_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_reviews_empty_description = /** @type {((inputs?: Account_Reviews_Empty_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Empty_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_empty_description(inputs)
	return en_account_reviews_empty_description(inputs)
});